import { Col, Row } from "antd";
import styles from "./Home.module.css";
import { GoClock, GoStack } from "react-icons/go";
import { TbCurrencyDollar } from "react-icons/tb";
import {
  CPlusLogo,
  CSharpLogo,
  HtmlLogo,
  JavaLogo,
  JavascirptLogo,
  PythonLogo,
} from "../../../../../../assets/svgs";

const Home = ({ data, onChange }) => {
  const handleShowJobs = () => {
    onChange("Jobs");
  };
  const handleShowMore = () => {
    onChange("About");
  };

  const details = ["sub", "sector", "salary", "type"];
  const icons = {
    sector: <GoStack />,
    salary: <TbCurrencyDollar />,
    type: <GoClock />,
  };

  const techIcons = {
    Javascript: <JavascirptLogo />,
    Python: <PythonLogo />,
    "C-Sharp": <CSharpLogo />,
    "C++": <CPlusLogo />,
    Java: <JavaLogo />,
    HTML: <HtmlLogo />,
  };
  return (
    <>
      <div className={styles.content_wrap}>
        <div className={styles.content}>
          <div className={styles.title}>About</div>
          <div className={styles.description}>{data.about}</div>
        </div>
        <div className={styles.footer}>
          <div onClick={handleShowMore}>Show all details</div>
        </div>
      </div>
      <div className={styles.content_wrap}>
        <div className={styles.content}>
          <div className={styles.title}>Recent Job offerings</div>
          <div>
            <Row gutter={[8, 8]} className={styles.row}>
              {data?.jobs?.slice(0, 2)?.map((item) => {
                return (
                  <Col xs={24} sm={24} md={24} lg={12} xl={12} id="graph_col">
                    <div className={styles.box}>
                      <div>
                        <img
                          className={styles.img_wrap}
                          src={item.img}
                          alt={"job profile"}
                        />
                      </div>
                      <div>
                        <div className={styles.name}>{item.name}</div>
                        <div className={styles.details}>
                          {details.map((key) => {
                            return (
                              item[key] && (
                                <div>
                                  {icons[key] && icons[key]}
                                  {item[key]}
                                </div>
                              )
                            );
                          })}
                        </div>
                        <div className={styles.tags_wrap}>
                          {item?.tags?.map((tag) => (
                            <div>{tag}</div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        </div>
        <div className={styles.footer}>
          <div onClick={handleShowJobs}>Show all jobs</div>
        </div>
      </div>
      <div className={styles.content_wrap}>
        <div className={styles.content_2}>
          <div className={styles.title_2}>Tech stack</div>
          <div className={styles.icon_group}>
            {data?.techStack?.map((key) => (
              <div>{techIcons[key]}</div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
